import { TaskPane } from './taskpane/TaskPane';

function App() {
  return <TaskPane />;
}

export default App;
